import { FC, useEffect, useState } from "react"
import { usePluginspace } from "../../hooks/usePluginspace";
import SuccessImg from "../../assets/images/success-order.svg";
import SuccessImgFood from "../../assets/images/success-food.svg";
import { FaBoxOpen } from "react-icons/fa";
import styles from './index.module.css'


type StatusResponseType = {
  id: number;
  name: string;
  slug: string;
  order: number;
  displayStatusWebapp: boolean;
};



type Props = {
  externalCodeERP: string
  orderIdExt: string
  status?: StatusResponseType[]
  statusOrder?: StatusResponseType
  config: any
  type: string
}

const InfoFinishedOrder: FC<Props> = ({ orderIdExt, externalCodeERP, status, statusOrder, config, type }) => {
  const [typePluginSpace, setTypePluginSpace] = useState<string>('')
  const { getThisPluginspace } = usePluginspace();


  async function getInfoPluginSpace() {
    try {
      const type = await getThisPluginspace();

      setTypePluginSpace(type!.type);
    } catch (error) {

    }
  }

  useEffect(() => {
    getInfoPluginSpace()
  }, [])

  return (
    <div className={styles.content}>
     
      <div className={styles.content_image}>
        {typePluginSpace === 'food' ?
          <img src={SuccessImgFood} alt="Pedido enviado" />
          :
          <img src={SuccessImg} alt="Pedido enviado" />
        }
      </div>
      <div className={styles.content_title}>
        <h4>O seu pedido foi finalizado.</h4>
      </div>
      <div className={styles.content_order} >
        <FaBoxOpen color="#5D8ED8" size={20} />
        <h4> Pedido {externalCodeERP ? externalCodeERP : orderIdExt}</h4>
      </div>

      <div className={styles.content_status_body}>
        <div className={styles.content_status}>
          {type === 'counter' ? (
            status?.map((oneStatus, index) => {
              if (oneStatus.order === 4) {
                return (<div key={oneStatus.id} className={oneStatus.id === statusOrder?.id ? `${styles.status_active} ${styles.success_extreme_left}` : `${styles.status} ${styles.success_extreme_left}`}
                  style={
                    oneStatus.id ===
                      statusOrder?.id
                      ? config?.webappcolor
                        .backgroundstatusactive
                        ? {
                          backgroundColor:
                            config
                              .webappcolor
                              .backgroundstatusactive,
                        }
                        : {}
                      : config?.webappcolor
                        .backgroundstatus
                        ? {
                          backgroundColor:
                            config
                              .webappcolor
                              .backgroundstatus,
                        }
                        : {}
                  }
                >
                  <p style={config?.webappcolor.fontstatus ? { color: config?.webappcolor.fontstatus } : {}}>
                    Recepcionado
                  </p>
                </div>)
              } else if (oneStatus.order === 5) {
                return (<div className={oneStatus.id === statusOrder?.id ? `${styles.status_active} ${styles.success_extreme_right}` : `${styles.status} ${styles.success_extreme_right}`}
                  style={
                    oneStatus.id ===
                      statusOrder?.id
                      ? config?.webappcolor
                        .backgroundstatusactive
                        ? {
                          backgroundColor:
                            config
                              .webappcolor
                              .backgroundstatusactive,
                        }
                        : {}
                      : config?.webappcolor
                        .backgroundstatus
                        ? {
                          backgroundColor:
                            config
                              .webappcolor
                              .backgroundstatus,
                        }
                        : {}
                  }
                >
                  <p style={config?.webappcolor.fontstatus ? { color: config?.webappcolor.fontstatus } : {}}>
                    Concluído
                  </p>
                </div>)
              }
            })
          ) :
            status?.map((oneStatus, index) => {
              if (index === 0) {
                return (
                  <div
                    key={oneStatus.id}
                    className={oneStatus.id === statusOrder?.id ? `${styles.status_active} ${styles.success_extreme_left}` : `${styles.status} ${styles.success_extreme_left}`}
                    style={
                      oneStatus.id ===
                        statusOrder?.id
                        ? config?.webappcolor
                          .backgroundstatusactive
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatusactive,
                          }
                          : {}
                        : config?.webappcolor
                          .backgroundstatus
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatus,
                          }
                          : {}
                    }
                  >
                    <p style={config?.webappcolor.fontstatus ? { color: config?.webappcolor.fontstatus } : {}}>
                      {oneStatus.name}
                    </p>
                  </div>
                );
              } else if (index === status.length - 1) {
                return (
                  <div
                    className={oneStatus.id === statusOrder?.id ? `${styles.status_active} ${styles.success_extreme_right}` : `${styles.status} ${styles.success_extreme_right}`}
                    style={
                      oneStatus.id ===
                        statusOrder?.id
                        ? config?.webappcolor
                          .backgroundstatusactive
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatusactive,
                          }
                          : {}
                        : config?.webappcolor
                          .backgroundstatus
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatus,
                          }
                          : {}
                    }
                  >
                    <p style={config?.webappcolor.fontstatus ? { color: config?.webappcolor.fontstatus } : {}}>
                      {
                        oneStatus.slug === 'order_delivered' && type === 'withdraw' ?
                          'Retirado' :
                          (oneStatus.slug === 'packaged' && type === 'withdraw' ? 'Pronto para retirar' : oneStatus.name)
                      }
                    </p>
                  </div>
                );
              } else {
                return (
                  <div
                    className={
                      oneStatus.id ===
                        statusOrder?.id
                        ? styles.status_active
                        : styles.status
                    }
                    style={
                      oneStatus.id ===
                        statusOrder?.id
                        ? config?.webappcolor
                          .backgroundstatusactive
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatusactive,
                          }
                          : {}
                        : config?.webappcolor
                          .backgroundstatus
                          ? {
                            backgroundColor:
                              config
                                .webappcolor
                                .backgroundstatus,
                          }
                          : {}
                    }
                  >
                    <p style={config?.webappcolor.fontstatus ? { color: config?.webappcolor.fontstatus } : {}}>
                      {
                        oneStatus.slug === 'order_delivered' && type === 'withdraw' ?
                          'Retirado' :
                          (oneStatus.slug === 'packaged' && type === 'withdraw' ? 'Pronto para retirar' : oneStatus.name)
                      }
                    </p>
                  </div>
                );
              }
            })}
        </div>
      </div>

    </div>
  )
}

export { InfoFinishedOrder }